import React, { Component } from 'react';
import { Row } from 'reactstrap';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ViewCard from '../../../../Components-2025/QuestionBank/ViewCard';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import appRoutes from '../../../config/AppRoutes';
import alertMessage from '../../../config/alertMessage';
import questionIcon from '../../../../assets/img/question_bank/question_icon-blu.svg';
import {
  chapterIdKey,
  isAttemptedKey,
  questionIdKey,
  questionKey,
  readingIdKay,
  readingNameKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';

export default class QuestionsList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      questionStatsTableName: '',
      isLoading: true,
      chapterName: '',
      selectedExamSubscriptionDetails: {},
      isUserSubscribed: false,
      pdfAlert: false,
    };
  }
  //* ===========================> {{ COMPONENT DID MOUNT START HERE }} <=====================================
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const {
      location: { state },
    } = this.props;
    if (state && state.listData && state.listData.length) {
      const { listData } = state;
      this.setState({ listData });
    } else {
      const { readingId, level } = this.props.params;
      const response = await apiServiceProvider['fetchQuestionsChapterWise']({ readingId, level });
      if (response.success) {
        const { questions, selectedExamSubscriptionDetails } = response;
        if (
          selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 ||
          selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${level}`]
        ) {
          this.setState({ isUserSubscribed: true });
        }
        this.setState({
          listData: questions,
          selectedExamSubscriptionDetails,
        });
      }
    }
    this.setState({ isLoading: false });
  };
  //* ===========================> {{ COMPONENT DID MOUNT ENDED HERE }} <=====================================

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };
  redirectToQuestion = async data => {
    const { listData, selectedExamSubscriptionDetails } = this.state;
    const { level } = this.props.params;
    const { router } = this.context;
    router.push({
      pathname: appRoutes.FRM_V2_QUESTION_BANK_QUESTION_VIEW.replace(
        ':readingId',
        data[readingIdKay],
      )
        .replace(':level', level)
        .replace(':questionId', data[questionIdKey]),
      state: { questionData: listData, selectedExamSubscriptionDetails },
    });
  };
  render() {
    const { listData, isLoading, isUserSubscribed, openPremiumPopup, pdfAlert } = this.state;
    const { level } = this.props.params;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={listData.length > 0 && listData[0][readingNameKey]}>
          <div>
            <CustomButton
              onClick={() =>
                router.push({
                  pathname: appRoutes.FRM_V2_QUESTION_BANK_READING_LIST.replace(
                    ':chapterId',
                    listData.length && listData[0][chapterIdKey],
                  ).replace(':level', level),
                })
              }
            >
              {messages.CHANGE_READING}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}=========================================== */}

        {/* //* ================={{ QUESTION CARD WITH COUNTS START HERE }}====================================*/}
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            {listData.length ? (
              listData.map(item => {
                return (
                  <ViewCard
                    headerIcon={questionIcon}
                    headerContent={`${item[readingNameKey]} (Q. ${item[questionIdKey]})`}
                    bodyContent={item[questionKey]}
                    key={item.id}
                    onClick={() => this.redirectToQuestion(item)}
                  >
                    {item[isAttemptedKey]  ? (
                      <div id='answered_status'>Answered</div>
                    ) : (
                      <div id='notanswered_status'>Not Answered </div>
                    )}
                  </ViewCard>
                );
              })
            ) : (
              <h1>No Data Found</h1>
            )}

            {!isUserSubscribed && (
              <ViewCard
                headerIcon={questionIcon}
                headerContent={messages.SUBSCRIBE_PRACTICE_QUESTION.replace(
                  'numberOfQuestion',
                  '2,000',
                )}
                bodyContent={alertMessage.messageContent_frm}
                paddingBox={'padding_box_free'}
              >
                <CustomButton
                  className='text-center d-block mx-auto'
                  onClick={() => router.push({ pathname: appRoutes.SUBSCRIBE })}
                >
                  Subscribe
                </CustomButton>
              </ViewCard>
            )}
          </Row>
        </LoaderWrapper>
        {/* //* ================={{ QUESTION CARD WITH COUNTS START HERE }}====================================*/}

        {/* //* ============================{{ PREMIUM MODAL START HERE }}========================================== */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
          exam={'frm'}
        />
        {/* //* ============================{{ PREMIUM MODAL ENDED HERE }}========================================== */}

        {/* //* ============================{{ PDF MODAL START HERE }}========================================== */}
        <PDFModelComponent
          type={'Question'}
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={pdfAlert}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
        {/* //* ============================{{ PDF MODAL ENDED HERE }}========================================== */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionsViewList/QuestionsList.jsx